import type { NodeVariant } from '@octopus-do/octopus-project-core'
import type React from 'react'

import { DEFAULT_PAGE_NAME } from '@/constants/defaultNames'
import { getFrameViewIcon } from '@/utils/getFrameViewIcon'
import css from './styles.module.css'

interface Props {
  variant: NodeVariant
  title: string
  colorHex: string
}

export const SeoSidebarHeader: React.FC<Props> = ({
  variant,
  title,
  colorHex,
}) => (
  <div className={css.seo_panel_header} style={{ color: colorHex }}>
    <div className={css.seo_panel_header_icon}>
      {getFrameViewIcon(variant, 16)}
    </div>
    <div className={css.seo_panel_header_title}>
      {title || DEFAULT_PAGE_NAME}
    </div>
  </div>
)
